import * as tslib_1 from "tslib";
import { SentimentColors } from "../../../constants";
import cx from 'classnames';
import { isInteger } from 'lodash';
import React, { PureComponent } from 'react';
import { getItem } from '../../../utils/card-value';
import { isFiniteNumber } from '../../../utils/checks';
import { SlashSvg } from '../../SvgIcons';
import { getSentimentColor } from '../utils';
import Styles from "./ValueViewChart.css";

var ValueViewChart =
/** @class */
function (_super) {
  tslib_1.__extends(ValueViewChart, _super);

  function ValueViewChart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ValueViewChart.prototype.render = function () {
    var _a = this.props,
        min = _a.min,
        max = _a.max,
        value = _a.value,
        getLabel = _a.getLabel;
    var color = getItem(SentimentColors, value, min, max);
    var label = getLabel(value);
    return React.createElement("div", {
      className: Styles.valueViewChart
    }, isFiniteNumber(value) ? React.createElement("span", {
      className: cx(Styles.label, getSentimentColor(color, Styles), isInteger(label) && Styles.round)
    }, label) : React.createElement(SlashSvg, null));
  };

  return ValueViewChart;
}(PureComponent);

export default ValueViewChart;